module.exports = __webpack_public_path__ + "static/media/1013197.d3188b73.png";